import { untilDestroy } from '@ngrx-utils/store';
import { AnimationBuilder, AnimationMetadata, AnimationPlayer } from '@angular/animations';
import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/scrolling';
import { Directive, ElementRef, Input, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { map } from 'rxjs/operators';

@Directive({
  selector: '[appAnimateWithScroll]'
})
export class AnimateWithScrollDirective implements OnInit, OnDestroy, AfterViewInit {

  @Input('appAnimateWithScroll') animation: AnimationMetadata | AnimationMetadata[];
  @Input() animationStart = 0;
  @Input() animationEnd = 200;

  private animationPlayer: AnimationPlayer;

  constructor(
    private scrollDispatcher: ScrollDispatcher,
    private animationBuilder: AnimationBuilder,
    private templateRef: ElementRef
  ) { }

  ngOnInit() {
    if (this.animation) {
      this.scrollDispatcher.scrolled().pipe(
        map((cdkScrollable: CdkScrollable) => cdkScrollable.measureScrollOffset('top')),
        untilDestroy(this)
      ).subscribe(scrollOffset => this.animateFromScroll(scrollOffset));
    }
  }

  ngOnDestroy() {}

  ngAfterViewInit() {
    if (this.animation && !this.animationPlayer) {
      this.animationPlayer = this.buildAnimationPlayer(this.animation);
    }
  }

  private buildAnimationPlayer(animation: AnimationMetadata | AnimationMetadata[]) {
    const animationFactory = this.animationBuilder.build(animation);
    const animationPlayer = animationFactory.create(this.templateRef.nativeElement);
    animationPlayer.init();
    return animationPlayer;
  }

  private animateFromScroll(scrollOffset: number) {
    if (scrollOffset >= this.animationStart) {
      const newPosition = (scrollOffset - this.animationStart) / this.animationEnd;
      this.animationPlayer.setPosition(newPosition);
    } else {
      this.animationPlayer.setPosition(0);
    }
  }

}
